import { mockedLoginHubGetPlayerEmailResponse, mockedLoginHubGetPlayerEmailResponseIsFacebookUser } from '../mocks';
import { ErrorResponse, LoginHubGetPlayerEmailResponse } from '../response';
import { LoginHubGetPlayerEmailAction } from './login-hub-get-player-email';

interface ResponseWithStatus {
	status: number;
}

type RegisterResponse = ResponseWithStatus;

export type LoginHubGetPlayerEmailErrorAction = (
) => Promise<RegisterResponse>;

const successLoginHubGetPlayerEmailMock: LoginHubGetPlayerEmailAction = async (): Promise<LoginHubGetPlayerEmailResponse | ErrorResponse> => {
	return Promise.resolve(mockedLoginHubGetPlayerEmailResponse);
};

const successLoginHubGetPlayerEmailIsFacebookUserMock: LoginHubGetPlayerEmailAction = async (): Promise<LoginHubGetPlayerEmailResponse | ErrorResponse> => {
	return Promise.resolve(mockedLoginHubGetPlayerEmailResponseIsFacebookUser);
};

const failMock: LoginHubGetPlayerEmailErrorAction = async (): Promise<ResponseWithStatus> => {
	return Promise.resolve({
		status: 500,
	});
};

export const loginHubGetPlayerEmailMocks: {
	successLoginHubGetPlayerEmail: LoginHubGetPlayerEmailAction;
	successLoginHubGetPlayerEmailIsFacebookUser: LoginHubGetPlayerEmailAction;
	failError: LoginHubGetPlayerEmailErrorAction;
} = {
	successLoginHubGetPlayerEmail: successLoginHubGetPlayerEmailMock,
	successLoginHubGetPlayerEmailIsFacebookUser: successLoginHubGetPlayerEmailIsFacebookUserMock,
	failError: failMock
};
